module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pa-3"
  }, [_c('v-dialog', {
    attrs: {
      "width": "450",
      "min-height": "500"
    },
    on: {
      "click:outside": _vm.limpiarValoresConfirmacion
    },
    model: {
      value: (_vm.isModalConfirmacion),
      callback: function($$v) {
        _vm.isModalConfirmacion = $$v
      },
      expression: "isModalConfirmacion"
    }
  }, [_c('v-card', {
    staticClass: "pa-5"
  }, [_c('h2', {
    staticClass: "text-center font-weight-700 my-2"
  }, [_vm._v("¿Deseas continuar con la generación de  tickets?")]), _c('div', {
    staticClass: "my-2 ma-4"
  }, [_c('div', {
    staticClass: "d-flex ai-center jc-center py-2"
  }, [_c('v-icon', {
    attrs: {
      "size": "150",
      "color": "background"
    }
  }, [_vm._v(" control_point_duplicate")])], 1), (_vm.isUploadModal) ? _c('div', {
    staticClass: "d-flex my-4"
  }, [_c('v-file-input', {
    attrs: {
      "color": "primary",
      "label": "Adjuntar sustento para las series (boleta/factura)",
      "solo": "solo",
      "multiple": false,
      "dense": "dense",
      "placeholder": "Selecciona un archivo",
      "persistent-hint": "persistent-hint",
      "hint": "Es importante adjuntar el sustento por que hay series que se encuentran en garantia."
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(ref) {
        var index = ref.index;
        var text = ref.text;

        return [(index < 2) ? _c('v-chip', {
          attrs: {
            "color": "primary",
            "dark": "",
            "label": "",
            "small": ""
          }
        }, [_vm._v(_vm._s(text))]) : (index === 2) ? _c('span', {
          staticClass: "text-overline grey--text text--darken-3 mx-2"
        }, [_vm._v("+" + _vm._s(_vm.files.length - 2) + " File(s)")]) : _vm._e()]
      }
    }], null, false, 2529350151),
    model: {
      value: (_vm.filesTickets),
      callback: function($$v) {
        _vm.filesTickets = $$v
      },
      expression: "filesTickets"
    }
  })], 1) : _vm._e(), _c('span', {
    staticClass: "text-muted font-size-11"
  }, [_vm._v("Este proceso generará " + _vm._s(_vm.equiposLista.length) + " tickets configurados previamente, Verificar.")])]), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "success",
      "block": "block",
      "small": !_vm.isMovil
    },
    on: {
      "click": _vm.fetchProcesoGenerarTickets
    }
  }, [_vm._v("Generar tickets")])], 1)], 1)], 1), _c('v-dialog', {
    attrs: {
      "width": "600",
      "min-height": "500"
    },
    on: {
      "click:outside": function($event) {
        return _vm.clsoeErroresEncontrados()
      }
    },
    model: {
      value: (_vm.isModalErroresEncontrados),
      callback: function($$v) {
        _vm.isModalErroresEncontrados = $$v
      },
      expression: "isModalErroresEncontrados"
    }
  }, [_c('v-card', {
    staticClass: "pa-4"
  }, [_c('div', {
    staticClass: "px-4 py-3"
  }, [_c('h1', {
    staticClass: "text-center font-weight-700"
  }, [_vm._v("Validaciones")])]), _c('v-card', {
    staticClass: "overflow-y-auto elevation-0",
    attrs: {
      "max-height": "calc(100vh - 380px)"
    }
  }, _vm._l((_vm.erroresValidacion), function(e, index) {
    return _c('div', {
      key: index,
      staticClass: "pa-1 font-size-12 font-weight-700"
    }, [_vm._v("• " + _vm._s(e))])
  }), 0), _c('v-card-actions', {
    staticClass: "mt-4"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "block": "block",
      "small": !_vm.isMovil
    },
    on: {
      "click": function($event) {
        return _vm.clsoeErroresEncontrados()
      }
    }
  }, [_vm._v("Cerrar")])], 1)], 1)], 1), _c('v-card', {
    staticClass: "mx-auto elevation-1"
  }, [_c('div', {
    staticClass: "d-flex",
    class: {
      'fd-column': _vm.isMovil
    }
  }, [_c('div', {
    staticClass: "flex-1"
  }, [_c('v-card-title', {
    staticClass: "pa-3 pl-4"
  }, [_c('span', {
    staticClass: "font-weight-700",
    class: {
      'font-size-17': _vm.isMovil
    }
  }, [_vm._v("Generar tickets por plantilla")])]), _c('v-card-subtitle', {
    staticClass: "pb-3 font-size-13"
  }, [_vm._v("Sube tu plantilla y edita los valores antes de generar")])], 1), (_vm.isMovil) ? _c('v-divider') : _vm._e(), (_vm.equiposLista.length) ? _c('v-card', {
    staticClass: "d-flex elevation-0 ai-center",
    class: {
      'ma-2': !_vm.isMovil
    }
  }) : _vm._e()], 1), _c('v-divider'), (_vm.equiposLista.length) ? _c('v-card', {
    staticClass: "elevation-0",
    attrs: {
      "height": _vm.isMovil ? 'calc(100vh - 192px)' : 'calc(100vh - 144px)'
    }
  }, [_c('v-data-table', {
    staticClass: "elevation-0",
    attrs: {
      "height": _vm.isMovil ? 'calc(100vh - 295px)' : 'calc(100vh - 194px)',
      "fixed-header": "fixed-header",
      "headers": _vm.headers,
      "items": _vm.equiposLista,
      "dense": "dense",
      "hide-default-footer": "hide-default-footer",
      "disable-pagination": "disable-pagination"
    },
    scopedSlots: _vm._u([{
      key: "item.status",
      fn: function(ref) {
        var item = ref.item;

        return [(item.status) ? _c('v-icon', {
          attrs: {
            "color": "success"
          }
        }, [_vm._v("check_circle")]) : _c('v-icon', {
          attrs: {
            "color": "warning"
          }
        }, [_vm._v("pending_actions")])]
      }
    }, {
      key: "item.usuario",
      fn: function(ref) {
        var item = ref.item;

        return [_c('span', {
          staticClass: "font-weight-700",
          class: {
            'error--text': !item.usuario
          }
        }, [_vm._v(_vm._s(item.usuario || 'Es requerido'))])]
      }
    }, {
      key: "item.serie",
      fn: function(ref) {
        var item = ref.item;

        return [_c('span', {
          staticClass: "font-weight-700",
          class: {
            'error--text': !item.serie
          }
        }, [_vm._v(_vm._s(item.serie || 'Es requerido'))])]
      }
    }, {
      key: "item.tipo",
      fn: function(ref) {
        var item = ref.item;

        return [_c('span', {
          staticClass: "font-weight-700",
          class: {
            'error--text': !item.tipo
          }
        }, [_vm._v(_vm._s(item.tipo || 'Es requerido'))])]
      }
    }, {
      key: "item.numeroFactura",
      fn: function(ref) {
        var item = ref.item;

        return [_c('span', {
          staticClass: "font-weight-700"
        }, [_vm._v(_vm._s(item.numeroFactura))])]
      }
    }, {
      key: "item.sigueEnGarantia",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-checkbox', {
          staticClass: "ma-0",
          attrs: {
            "hide-details": "hide-details",
            "color": "primary",
            "disabled": "disabled"
          },
          model: {
            value: (item.sigueEnGarantia),
            callback: function($$v) {
              _vm.$set(item, "sigueEnGarantia", $$v)
            },
            expression: "item.sigueEnGarantia"
          }
        })]
      }
    }, {
      key: "item.comproAqui",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-checkbox', {
          staticClass: "ma-0",
          attrs: {
            "hide-details": "hide-details",
            "color": "primary",
            "disabled": "disabled"
          },
          model: {
            value: (item.comproAqui),
            callback: function($$v) {
              _vm.$set(item, "comproAqui", $$v)
            },
            expression: "item.comproAqui"
          }
        })]
      }
    }], null, false, 295122118)
  }), _c('v-divider'), _c('div', {
    staticClass: "pa-3 d-flex ai-center flex-wrap"
  }, [(!_vm.isMovil) ? _c('small', {
    staticClass: "text-muted font-size-11"
  }, [_vm._v("Mostrando " + _vm._s(_vm.equiposLista.length) + " registros")]) : _vm._e(), _c('v-spacer'), _c('v-btn', {
    class: {
      'mx-2': !_vm.isMovil
    },
    attrs: {
      "color": "error",
      "small": !_vm.isMovil,
      "block": _vm.isMovil,
      "disabled": _vm.isLoadingProceso
    },
    on: {
      "click": function($event) {
        return _vm.volverASeleccionar()
      }
    }
  }, [_c('v-icon', [_vm._v("arrow_back")]), _c('span', [_vm._v("Volver adjuntar")])], 1), _c('v-btn', {
    class: {
      'mt-2': _vm.isMovil
    },
    attrs: {
      "color": "success",
      "small": !_vm.isMovil,
      "block": _vm.isMovil,
      "disabled": !_vm.equiposLista.length || _vm.isLoadingProceso
    },
    on: {
      "click": function($event) {
        return _vm.openModalValidarDatos()
      }
    }
  }, [_vm._v("Iniciar proceso")])], 1)], 1) : _c('v-card', {
    staticClass: "d-flex jc-center ai-center elevation-0 flex-wrap",
    attrs: {
      "height": "calc(100vh - 144px)",
      "id": "fileSelect"
    }
  }, [(_vm.renderInputFile) ? _c('input', {
    staticClass: "display-none",
    attrs: {
      "id": "fileElement",
      "type": "file",
      "accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    },
    on: {
      "change": _vm.decodedExcel
    }
  }) : _vm._e(), _c('v-card', {
    staticClass: "ma-4 d-flex ai-center jc-center fd-column pa-8",
    attrs: {
      "width": _vm.isMovil ? '100%' : 300,
      "height": _vm.isMovil ? 220 : 300,
      "color": "primary white--text",
      "hover": "hover"
    },
    on: {
      "click": _vm.adjuntarFileExcel
    }
  }, [_c('v-icon', {
    staticClass: "animated fadeInUp",
    attrs: {
      "size": "60"
    }
  }, [_vm._v("cloud_upload")]), _c('h1', {
    staticClass: "font-weight-700 animated fadeInLeft"
  }, [_vm._v("Adjuntar")])], 1), _c('v-card', {
    staticClass: "ma-4 d-flex ai-center jc-center fd-column pa-8",
    attrs: {
      "width": _vm.isMovil ? '100%' : 300,
      "height": _vm.isMovil ? 220 : 300,
      "color": "secondary primary--text",
      "hover": "hover"
    },
    on: {
      "click": _vm.fetchDescargarPlantilla
    }
  }, [_c('v-icon', {
    staticClass: "animated fadeInDown",
    attrs: {
      "size": "60",
      "color": "primary"
    }
  }, [_vm._v("cloud_download")]), _c('h1', {
    staticClass: "font-weight-700 animated fadeInLeft"
  }, [_vm._v("Plantilla")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73736754","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/View_creacion_ticket_multiple.vue
// module id = 508
// module chunks = 1